<template>
  <div>
    <nav id="nav_id" class="nav">
      <div class="inner">
        <div class="nav_top">
          <div class="inner">
            <h1 class="h1">
              <span>소식 알림</span>
            </h1>
          </div>
        </div>
        <div class="nav_btm">
          <div class="inner">
            <div class="line dep01">
              <div class="inner">
                <ul>
                  <li>
                    <router-link tag="button" to="/news/asctn"
                      ><span>협회 소식</span></router-link
                    >
                  </li>
                  <li>
                    <router-link tag="button" to="/news/notice"
                      ><span>공지사항</span></router-link
                    >
                  </li>
                  <li>
                    <router-link tag="button" to="/news/kfood"
                      ><span>외식 산업 뉴스</span></router-link
                    >
                  </li>
                  <li>
                    <router-link tag="button" to="/news/data"
                      ><span>자료실</span></router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'news-index'
}
</script>

<style scoped></style>
